var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 7.8125C4.75 7.50781 4.98438 7.25 5.3125 7.25H9.25V4.25H6.25C5.82812 4.25 5.5 3.92188 5.5 3.5V0.5H1.375C0.742188 0.5 0.25 1.01562 0.25 1.625V11.375C0.25 12.0078 0.742188 12.5 1.375 12.5H8.125C8.73438 12.5 9.25 12.0078 9.25 11.375V8.375H5.3125C4.98438 8.375 4.75 8.14062 4.75 7.8125ZM6.25 0.5V3.5H9.25L6.25 0.5ZM13.5625 7.41406L11.6875 5.53906C11.4531 5.32812 11.1016 5.32812 10.8906 5.53906C10.6562 5.77344 10.6562 6.125 10.8906 6.33594L11.8281 7.25H9.25V8.375H11.8281L10.9141 9.3125C10.7969 9.40625 10.75 9.54688 10.75 9.6875C10.75 9.85156 10.7969 9.99219 10.9141 10.0859C11.125 10.3203 11.4766 10.3203 11.6875 10.0859L13.5625 8.21094C13.7969 8 13.7969 7.64844 13.5625 7.41406Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.b1dcf0675eec3a6a213386518c5f6a0b.svg";
export { ForwardRef as ReactComponent };